export { default } from "./DetailSocial";
export * from "./DetailSocial";
